$(document).ready(function() {

    /*******************************************/
    //Form Validation
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.parents('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });

    /*******************************************/
    //Lightbox Initiations
    $('.js-inline-popup').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true
    });

    $('.js-image-popup').magnificPopup({
        type: 'image',
        showCloseBtn: true,
        closeOnBgClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*******************************************/
    // Tabs
    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });

    /*******************************************/
    // JS category accordion
    $('.js-toggle-category').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');

        // if ($(this).parent().hasClass('active')) {
        //     $(this).find(img)
        // }
    });


    /*******************************************/
    // JS toggle label on form-fields
    // listening actives
    $('.form-field input, .form-field select, .form-field textarea')
        .blur(function() {
            if ( $(this).val() ) {
                $(this).parent().addClass('active')
                $(this).parent().removeClass('active-w-span')
            } else {
                $(this).parent().removeClass('active')
                $(this).parent().removeClass('active-w-span')
            }
        })
        .focus(function() {
            if ( $(this).val() ) {
                $(this).parent().addClass('active')
            } else {
                $(this).parent().removeClass('active')
                $(this).parent().addClass('active-w-span')
            }
        });

    $('.fileuploader-input-caption span').empty().text('<b>Add file</b> or drop files here');

    /*******************************************/
    // JS close toast
    $('.js-close-toast').on('click', function(e) {
        e.preventDefault();
        $(this).hide();
    });

    if ($('.toast').length) {
        setTimeout(() => {
        $('.js-close-toast').trigger()
        }, 5000)
    } else {
        console.log('no toast')
    }

    /*******************************************/

});
/*******************************************/


$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};

/*******************************************/






// WEBPACK FOOTER //
// ./resources/assets/frontend/js/scripts/common.js